export enum AnimatedModalState {
  visible = 'visible',          // Completely visible
  hidden = 'hidden'         // Completely hidden
}
